import React from "react";
import { Pulse } from "@phosphor-icons/react";

const TONES = {
  good: "bg-emerald-50 border-emerald-700 text-emerald-900",
  warn: "bg-amber-50 border-amber-600 text-amber-900",
  info: "bg-sky-50 border-sky-700 text-sky-900",
  idle: "bg-zinc-50 border-zinc-400 text-zinc-700",
};

const NAMES = {
  page_view: "page view", form_start: "form start", form_submit_success: "lead submit",
  lead_submit: "lead submit", thank_you_page: "thank you", thank_you: "thank you", custom_event: "custom",
};

const ORDER = ["page_view", "form_start", "form_submit_success", "lead_submit", "thank_you_page", "thank_you", "custom_event"];
const rank = (e) => (ORDER.indexOf(e) === -1 ? ORDER.length : ORDER.indexOf(e));

function summarize(h) {
  if (!h.delivered) return { tone: "idle", text: "No live events in 24h", tip: "No real visitor has triggered this code in the last 24 hours." };
  if (h.errors) return { tone: "warn", text: `Heard ${h.heard} · ${h.errors} error${h.errors === 1 ? "" : "s"} · 24h`, tip: "Some events made the code throw an error. Use Test my code to see the error." };
  if (h.heard) return { tone: "good", text: `Heard ${h.heard} event${h.heard === 1 ? "" : "s"} · 24h`, tip: "The code's CustomTracking.on listeners ran on real traffic." };
  return { tone: "info", text: `${h.delivered} sent · none heard · 24h`, tip: "Events reached the code but it has no CustomTracking.on listener for them. That's fine if the code fires on its own when the page loads." };
}

// Live-traffic health for an approved, enabled tracking row (last 24 hours).
export function TrackingHealthBadge({ row, testId }) {
  if (row.status !== "approved" || !row.enabled || !row.health) return null;
  const h = row.health;
  const s = summarize(h);
  const parts = Object.entries(h.events || {})
    .filter(([, v]) => v.delivered)
    .sort(([a], [b]) => rank(a) - rank(b))
    .map(([e, v]) => `${NAMES[e] || e} ${v.heard}/${v.delivered}`);
  return (
    <div className="mt-1" data-testid={testId}>
      <span title={s.tip} data-testid={`${testId}-label`}
        className={`inline-flex items-center gap-1 border px-1.5 py-0.5 text-[10px] uppercase tracking-widest ${TONES[s.tone]}`}>
        <Pulse size={11} weight="bold" />{s.text}
      </span>
      {parts.length > 0 && (
        <div className="text-[10px] font-mono text-zinc-600 mt-0.5" data-testid={`${testId}-events`}>
          {parts.join(" · ")} heard
        </div>
      )}
    </div>
  );
}
